export default "__VITE_ASSET__CEacelPe__"